import styled from 'styled-components/macro'

import { mq } from 'styles/mq'
import { Thread } from 'styles/misc'
import { Title as TitleBase } from 'components/misc'
import { ActiveArea } from 'components/alphabet/styled'

export const ImageWrapper = styled.div`
  position: relative;
`

export const Picture = styled.picture`
  img {
    display: block;
    max-width: 100%;
    margin: 5rem auto;
    ${mq.smallOnly} {
      margin: 4rem auto 8rem;
    }
  }
`

export const StyledActiveArea = styled(ActiveArea)`
  &[data-char='ДЖ'] {
    --row: 2;
    left: 0%;
    width: 20%;

    ${mq.medium} {
      --row: 1;
      left: 48%;
      width: 12%;
    }
  }

  &[data-char='ДЗ'] {
    --row: 2;
    left: 25%;
    width: 22%;

    ${mq.medium} {
      --row: 1;
      left: 60%;
      width: 12%;
    }
  }

  &[data-char='ЗЬ'] {
    --row: 3;

    left: 14%;
    width: 20%;

    ${mq.medium} {
      --row: 2;

      left: 0%;
      width: 7.3%;
    }
  }

  &[data-char='О'] {
    --row: 5;

    left: 15%;
    width: 15%;

    ${mq.medium} {
      --row: 3;

      left: 0%;
      width: 5%;
    }
  }

  &[data-char='СЬ'] {
    --row: 5;

    left: 84%;
    width: 16%;

    ${mq.medium} {
      --row: 3;

      left: 36%;
      width: 11%;
    }
  }

  &[data-char='ТШ'] {
    --row: 6;

    left: 40%;
    width: 23%;

    ${mq.medium} {
      --row: 3;

      left: 70%;
      width: 13%;
    }
  }
`

export const Title = styled(TitleBase)`
  ${mq.medium} {
    &::before {
      ${Thread}
      left: 50%;
      bottom: -3rem;
      transform: translate(-50%, 0);
      width: 100%;
      aspect-ratio: 2182 / 305;
      mask-image: url("data:image/svg+xml,%3Csvg width='2182' height='305' viewBox='0 0 2182 305' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.189941 178.35C178.17 106.98 363.04 52.77 551.39 16.71C611.66 5.17 673.34 -4.54 734.2 3.37C746.07 4.91 759.87 8.74 763.87 20.02C770.41 38.42 745.46 52.13 739.13 70.6C732.37 90.32 749.93 111.58 770.09 116.88C790.25 122.18 811.45 116.31 831.57 110.85C904.44 91.07 978.69 76.38 1053.6 66.93C1069.88 64.88 1091.5 66.4 1095.82 82.23C1098.04 90.37 1094.19 99.13 1095.89 107.4C1099.7 125.95 1125.2 128.07 1143.9 125.11C1189.61 117.87 1235.12 106.57 1281.38 107.57C1327.65 108.57 1376.33 124.04 1404.73 160.58C1433.13 197.12 1422.24 298.94 1395.21 284.69C1371.94 272.43 1452.52 223.76 1495.07 220.24C1612.19 210.56 1725.4 257.99 1840.22 283.04C1952.03 307.44 2068.43 310.66 2181.42 292.49' stroke='black' stroke-width='1.5' vector-effect='non-scaling-stroke' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");
    }
  }
`
